import { render, staticRenderFns } from "./Recents.vue?vue&type=template&id=74b60a00&scoped=true&"
import script from "./Recents.vue?vue&type=script&lang=js&"
export * from "./Recents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b60a00",
  null
  
)

export default component.exports